"use client";

import { useMarketingText } from "@/lib/i18n/marketingClient";

/**
 * Marketing-only illustration of cloud backup destinations. Push-only package
 * to Dropbox or GitHub; not live sync UI.
 */
export function CloudBackupGlimpse() {
  const localize = useMarketingText();
  return (
    <figure
      aria-label={localize(
        "Novilot backing up a manuscript package to Dropbox or a private GitHub repo.",
      )}
      className="w-full max-w-xl mx-auto lg:max-w-none"
    >
      <div className="rounded-2xl border border-border/80 bg-muted/20 p-5 shadow-sm">
        <div className="rounded-xl border border-border bg-background overflow-hidden">
          <div className="px-4 py-3 border-b border-border flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-semibold">{localize("Cloud backup")}</p>
              <p className="text-xs text-muted-foreground">{localize("Push package. Not two-way sync.")}</p>
            </div>
            <span className="text-[11px] uppercase tracking-wide text-accent shrink-0">{localize("Ready")}</span>
          </div>
          <ul className="divide-y divide-border text-sm">
            <li className="px-4 py-3 flex justify-between gap-3">
              <span>{localize("Chapters (Markdown)")}</span>
              <span className="text-muted-foreground">{localize("Included")}</span>
            </li>
            <li className="px-4 py-3 flex justify-between gap-3">
              <span>{localize("Story bible")}</span>
              <span className="text-muted-foreground">{localize("Included")}</span>
            </li>
            <li className="px-4 py-3 flex justify-between gap-3">
              <span>{localize("Outline cards")}</span>
              <span className="text-muted-foreground">{localize("Included")}</span>
            </li>
          </ul>
          <div className="px-4 py-3 border-t border-border flex flex-wrap gap-2 text-xs">
            <span className="rounded-lg bg-accent text-accent-foreground px-2.5 py-1 font-medium">
              {localize("Dropbox")}
            </span>
            <span className="rounded-lg border border-border px-2.5 py-1 font-medium">
              {localize("GitHub (private repo)")}
            </span>
          </div>
        </div>
      </div>
    </figure>
  );
}
